import { Box } from '@factorialco/deprecated-design-system'

import ProjectsLandingDescription from './ProjectsLandingDescription'
import StepsSection from './StepsSection'

interface ProjectsLandingPageContent {
  onButtonClick: () => void
}

const ProjectsLandingPageContent: React.FC<ProjectsLandingPageContent> = ({ onButtonClick }) => {
  return (
    <Box flexDirection="column" gap="s32" gapDivider>
      <ProjectsLandingDescription onPrimaryButtonClick={onButtonClick} />
      <StepsSection onPrimaryButtonClick={onButtonClick} />
    </Box>
  )
}

export default ProjectsLandingPageContent
